import React, { useEffect, useRef, useState } from 'react';
import { Form, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import prodIcon from '../../assets/card-icons/stable.svg';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import InfoCard from '../../components/Cards/InfoCard';
import CodeView from '../../components/CodeView/CodeView';
import MainContainer from "../../components/container/MainContainer";
import CustomButton from '../../components/CustomButton/CustomButton';
import FAQ from '../../components/FAQ/FAQ';
import JSONViewer from '../../components/JSONViewer/JSONViewer';
import MFTable from '../../components/MFTable/MFTable';
import Share from '../../components/Share/Share';
import { getDetails, postDetails, postDetailsBlob, postMultipartDetails } from '../../services/http/http.service';
import { setShowCTAModal, setUserCartItems, setWishListedItems } from '../../store/authentication/authentication.slice';
import { hideLoader, showLoader } from '../../store/Loader/loader.slice';
import { getPageData } from '../../store/pageData/pageData.actions';
import { setCartIDs, setOrderTab, setShowSideModal, setSideModalOption } from '../../store/selectedAPIs/selectedAPIs.slice';
import { useAppDispatch, useAppSelector } from '../../store/storeRequests';
import APIList from '../../utils/constants/APIList';
import BreadcrumbData from '../../utils/constants/BreadcrumbData.constants';
import { APIResponseCodes, tableKeys } from '../../utils/constants/keys.constants';
import StoreSelectors from '../../utils/constants/StoreSelectors.constants';
import decrypt from '../../utils/helpers/decrypt';
import './api-details.css';
import AceEditor from 'react-ace';
import copylink from '../../assets/copylink.svg';
import leftArrow from '../../assets/leftArrow.svg';
import rightArrow from '../../assets/rightArrow.svg';
import encrypt from '../../utils/helpers/encrypt';


// Import necessary modes and themes
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { NavList } from '../../utils/constants/navigation';
import { message } from '../../utils/constants/Messages';
import { showMessageOnFailure } from '../../store/error.actions';
import { setAlertMode, setMessage, setShowAlert } from '../../store/Alert/alert.slice';
import { BillingInfoModal } from '../../components/Cards/BillingInfo';
import RaiseRequestModal from './RaiseRequest';

require('codemirror/lib/codemirror.css');
require('codemirror/theme/material.css');
require('codemirror/mode/javascript/javascript.js');



interface ApiMapping {
    api_id: number;
    sequence: number;
    api_name: string;
    api_status: number;
    api_method: string;
    version_id: number;
}

interface Group {
    apiMappings: ApiMapping[];
    name: string;
}

interface ApiVersion {
    id: number;
    api_version: string;
}

interface ApiData {
    name: string;
    api_version: string;
    api_info: string;
    api_type: string;
    api_identifier: string;
    version_list: ApiVersion[];
    enviroment: string;
    master_api_id: number | null;
    ap_ver_id: string;
    input: any[];
    output: any[];
    headers: any[];
    URLParams: any[];
    method: string;
    link: string;
    uat_url: string;
    uat_code_content: string;
    uat_route: string;
    bodyParams: any[];
    request: any[];
    response: any[];
    params: string;
    group: Group;
    errorCodes: any[];
    requestCode: any;
    status_code: any;
    useCases: [];
    useCaseRequest: any;
    request_params: [];
    response_params: [],

}

const APIDetailsPage: React.FunctionComponent = () => {

    const isMounted = useRef(false)
    const params = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { cartIDs } = useAppSelector(StoreSelectors.SELECTED_STATE)
    const { wishListedItems, cartItems, prodCartItems, uatOrders, prodOrders, liveOrders, access } = useAppSelector(StoreSelectors.USER_STATE)    
    const [isAPIInfoActive, setIsAPIInfoActive] = useState(1)
    const [isTryItOutActive, setIsTryItOutActive] = useState(1)
    const [docTab, setDocTab] = useState({ requestTab: true, responseTab: false })
    const [showJSONView, setShowJSONView] = useState({ requestTab: false, responseTab: false })
    const [showVersionDropdown, setShowVersionDropdown] = useState(false)
    const [selectedVersion, setSelectedVersion] = useState('')
    const [isRunClicked, setIsRunClicked] = useState(false);
    const [useCases, setUseCases] = useState<any>([]);
    const [selectedUseCase, setSelectedUseCase] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState('Node.js');
    const [showResponse, setShowResponse] = useState(false);
    const [responseContent, setResponseContent] = useState('');
    const loadEditor = useRef(false)
    const [initialContent] = useState("");
    const [statusCode, setStatusCode] = useState<number | null>(null);
    const [statusHide, setStatusHide] = useState(true);
    const printRef = useRef<HTMLDivElement>(null);
    const apiDetailsRef = useRef<HTMLDivElement>(null);

    //---------------------state after Group based Pricing----------------------
    const [selectedGroupVersion, setSelectedGroupVersion] = useState('');
    const [groupVersions, setGroupVersions] = useState<any[]>([]);
    const [groupVersionAPIs, setGroupVersionAPIs] = useState<any[]>([]);
    const [currentGroupVersionAPIndex, setCurrentGroupVersionAPIndex] = useState(0);
    const [currentGroupVersionAPIs, setCurrentGroupVersionAPIs] = useState<any>([]);
    const [currentVersionData, setCurrentVersionData] = useState<any>(null);
    const [apiEnvironment, setApiEnvironment] = useState<'UAT' | 'PROD' | null>(null);
    const [apiData, setAPIData] = useState<ApiData>({
        name: '',
        api_version: '',
        api_info: '',
        api_type: '',
        api_identifier: '',
        version_list: [{ id: 0, api_version: '' }],
        enviroment: '',
        master_api_id: null,
        ap_ver_id: '',
        input: [],
        output: [],
        headers: [],
        URLParams: [],
        method: '',
        link: '',
        uat_url: '',
        uat_code_content: '',
        uat_route: "",
        bodyParams: [],
        request: [],
        response: [],
        params: "",
        group: { apiMappings: [], name: '', },
        errorCodes: [],
        requestCode: '',
        status_code: "",
        useCases: [],
        request_params: [],
        response_params: [],
        useCaseRequest: {}

    })
    //-----------------------State of Group Data-------------------------------
    const [groupData, setGroupData] = useState<any>({
        group_id: 0,
        group_name: '',
        group_type: '',
        group_versions: [],
    })


    const [wishlisted, setWishlisted] = useState([] as any)
    const [faqData, setFaqData] = useState([])
    const [showShare, setShowShare] = useState(false)
    const [copyKeyText, setCopyKeyText] = useState('copy')
    const [copyUrlText, setCopyUrlText] = useState('copy')
    const [copyRequest, setCopyRequest] = useState('copy')
    const [copyResponse, setCopyResponse] = useState('copy')
    const [isDownload, setisDownload] = useState(false)
    const [isGroupSet, setIsGroupSet] = useState(false)

    const [requiredPresent, setRequiredPresent] = useState({
        request: true,
        response: false,
        headers: false,
        params: false
    });
    // -----------------------BillingInfo---------------------
    const [showBillingModal, setShowBillingModal] = useState(false);
    const [showRaiseRequestModal, setShowraiseRequestModal] = useState(false);
    const [raiseMeta, setRaiseMeta] = useState<{ groupId?: number; groupVersionId?: number; id?: number }>({});

    const [errorCodesPage, setErrorCodesPage] = useState(1);

    const errorCodesPageSize = 10;

    // Memoize paginated error codes to ensure re-render
    const paginatedErrorCodes = React.useMemo(() => {
        return apiData.errorCodes.slice((errorCodesPage - 1) * errorCodesPageSize, errorCodesPage * errorCodesPageSize);
    }, [apiData.errorCodes, errorCodesPage, errorCodesPageSize]);

    const displayedErrorCodes = isDownload ? apiData.errorCodes : paginatedErrorCodes;
    

    const [billingForm, setBillingForm] = useState({
        billing_address: "",
        authorised_signatory: "",
    });
    let identifier = '';

    const prepareDataForState = (response: any) => {
        let required = {
            request: false,
            response: false,
            headers: false,
            params: false
        }
        setShowResponse(false);
        setResponseContent("");
        setStatusCode(null);
        setStatusHide(true);

        let uatURL = `// UAT API URL <br/> ${response.data.uat_route}<br/>`

        let paramsData = []

        if (Array.isArray(response.data.headers)) {
            if (response.data.headers.length === 0) {
                required = { ...required, headers: true }
            }
        }

        if (Array.isArray(response.data.query_params)) {
            if (response.data.query_params.length !== 0) {
                paramsData = response.data.query_params
            } else {
                required = { ...required, params: true }
            }
        }

        if (response.data.input.length !== 0) {
            required = { ...required, request: true }
        }
        const useCasesData = response.data.useCases.map((useCase: any) => ({
            body_params: useCase.body_params || [],
            headers: useCase.headers || [],
            request: useCase.request || [],
            response: useCase.response || []
        }));
        const { allRequests, allResponses, allHeaders, allBodyParams } = patchUseCasesData(useCasesData);

        setRequiredPresent(required)
        setAPIData({
            ...response.data, useCasesAllData: useCasesData, link: response.data?.link || '', URLParams: paramsData, uat_url: response.data.uat_route, uat_code_content: uatURL, request: allRequests,
            response: allResponses,
            headers: allHeaders,
            bodyParams: allBodyParams,
        })
        setSelectedVersion(`${response.data.api_version}`)
    }

    const patchUseCasesData = (useCasesAllData: any) => {
        const allRequests: any[] = [];
        const allResponses: any[] = [];
        const allHeaders: any[] = [];
        const allBodyParams: any[] = [];

        useCasesAllData.forEach((caseDetail: any) => {
            if (Array.isArray(caseDetail.request)) {
                allRequests.push(...caseDetail.request);
            } else if (caseDetail.request) {
                allRequests.push(caseDetail.request);
            }

            if (Array.isArray(caseDetail.response)) {
                allResponses.push(...caseDetail.response);
            } else if (caseDetail.response) {
                allResponses.push(caseDetail.response);
            }

            if (Array.isArray(caseDetail.headers)) {
                allHeaders.push(...caseDetail.headers);
            } else if (caseDetail.headers) {
                allHeaders.push(caseDetail.headers);
            }
            if (Array.isArray(caseDetail.body_params)) {
                allBodyParams.push(...caseDetail.body_params);
            } else if (caseDetail.body_params) {
                allBodyParams.push(caseDetail.body_params);
            }
        });

        return { allRequests, allResponses, allHeaders, allBodyParams };
    };

    const checkEnvironment = (link: string) => {
        if (link.toLowerCase().includes('/uat/')) {
            setApiEnvironment('UAT');
        }
        else {
            setApiEnvironment('PROD');
        }
    }

    const handleAPISelect = async (api_version: number, index: number, group_id: number, group_version_id: number) => {
        dispatch(showLoader(message.FETCHING_DETAILS));
        setCurrentGroupVersionAPIndex(index);
        try {
            const payload = {
                id: api_version,
                groupId: group_id,
                groupVersionId: group_version_id,
            }
            const response = await postDetails(APIList.GET_API_BY_IDS, payload);
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                prepareDataForState(response);
                identifier = response.data?.api_identifier;
                setUseCases(response.data.useCases || []);
                if (response.data.useCases.length > 0) {
                    let selected = response.data.useCases.filter((usecase: any) => {
                        return parseInt(usecase.is_default) === 1;
                    })[0];
                    if (!selected) { selected = response.data.useCases[0]; }
                    setSelectedUseCase(selected.id);
                    getSnippet(response.data.method, selected);
                }
                const faqResponse = await getDetails(APIList.GET_FAQ + `?identifier=api-${response.data.master_api_id}&status=1`)
                if (faqResponse.statusCode === APIResponseCodes.SUCCESS) {
                    setFaqData(faqResponse.data)
                }
            }
        } catch (error) {
            console.error('Error fetching API details:', error);
        } finally {
            dispatch(hideLoader());
        }
    };
    const getGroupVersion = (response: any) => {
        const groupVersion: any[] = response.data.group_versions.map((g: any) => {
            return g.group_version;
        });
        setGroupVersions(groupVersion);
    }
    const getAPIbyGroupVersionId = (selectedVersionData: any) => {
        const group_Apis = selectedVersionData.apis;
        const firstGroupVersion = group_Apis?.map((api: any) => {
            return { api_id: api.api_id, api_name: api.api_name, api_version: api.api_version };
        });
        setGroupVersionAPIs(firstGroupVersion);
    };

    const getGROUPbyID = async () => {
        dispatch(showLoader(message.GETTING_API_DETAILS))
        if (typeof params.apiID !== 'undefined') {
            const response = await postDetails(APIList.GET_GROUP_BY_ID, { id: parseInt(decodeURIComponent(decrypt(params.apiID))) }, getGROUPbyID)
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                getGroupVersion(response);
                getAPIbyGroupVersionId(response);
                const groupName = response.data.group_name;
                const groupId = response.data.group_id;
                const groupType = response.data.group_type;
                setGroupData({
                    group_name: groupName,
                    group_id: groupId,
                    group_type: groupType,
                    group_versions: response.data.group_versions,
                })
                if (response.data.group_versions.length > 0) {

                    // Default to the latest NON-deprecated version.
                    // Versions arrive newest-first from the backend; if the latest is
                    // deprecated we fall through to the next one. If every version is
                    // deprecated, fall back to the first so the page still renders.
                    const defaultVersionData =
                        response.data.group_versions.find((v: any) => !v.is_deprecated) ||
                        response.data.group_versions[0];

                    const defaultCurrentVersion = defaultVersionData.group_version
                    const defaultCurrentVersionid = defaultVersionData.group_version_id
                    const defaultCurrentVersionApi = defaultVersionData.apis
                    setGroupVersionAPIs(defaultCurrentVersionApi);
                    setSelectedGroupVersion(defaultCurrentVersion);
                    if (defaultVersionData.apis.length > 0) {
                        handleAPISelect(defaultVersionData.apis[0].api_version, 0, groupId, defaultCurrentVersionid);
                    }
                }
                const faqResponse = await getDetails(APIList.GET_FAQ + `?identifier=api-${response.data.master_api_id}&status=1`)
                if (faqResponse.statusCode === APIResponseCodes.SUCCESS) {
                    setFaqData(faqResponse.data)
                }
            }
            setIsGroupSet(true);
        }
        dispatch(hideLoader())
    }

    const getSnippet = async (method: string, useCaseData: any) => {
        dispatch(showLoader(message.GETTING_API_DETAILS));
        try {
            const payload = {
                language: "nodejs",
                method: method,
            };
            const response = await postDetails(APIList.Get_snippet_data, { data: encrypt(payload) }, getSnippet);
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                setAPIData((prevData) => ({
                    ...prevData,
                    requestCode: patchCodeSnippet(response.data[0]?.code || '', useCaseData, identifier),
                    response: useCaseData.response,
                    status_code: useCaseData.status_code,
                    bodyParams: useCaseData.body_params,
                    headers: useCaseData.headers
                }));
                setTimeout(() => {
                    loadEditor.current = true
                }, 1000);
            } else {
                console.error('Failed to fetch use case details:', response.message);
            }
        } catch (error) {
            console.error('Error fetching use case details:', error);
        } finally {
            dispatch(hideLoader());
        }
    };

    const handleSelectLanguage = (language: any) => {
        setSelectedLanguage(language);
    };

    const getDataAccordingUseCase = (apiId: any, useCaseId: any) => {
        setResponseContent('');
        setStatusCode(null)
        setStatusHide(true)
        setSelectedUseCase(useCaseId);
        const selected = apiData.useCases.filter((usecase: any) => usecase.id === useCaseId);
        loadEditor.current = false;
        getSnippet(apiData.method, selected[0])
        setTimeout(() => {
            loadEditor.current = true

        }, 1000);
    };

    useEffect(() => {
        if (isMounted.current === false) {
            getGROUPbyID()
        }
        isMounted.current = true
    }, [])

    useEffect(() => {
        if (isGroupSet && (location?.state?.from === NavList.API_LISTING_PRODUCTION ||
            location?.state?.from === NavList.API_LISTING_LIVE ||
            location?.state?.from === NavList.ORDERS || location?.state?.from === NavList.CART)) {
            setSelectedGroupVersion(location?.state?.group_version);
            getGroupAPIVersionData(location?.state?.group_version);

            if (groupData && groupData.group_versions[0].apis.length > 0) {
                const selectedGroupVersion = groupData.group_versions.find((item: any) => item.group_version_id === location?.state?.group_version_id)
                handleAPISelect(selectedGroupVersion.apis[0].api_version, 0, groupData.group_id, currentVersionData.group_version_id);
            }
        }
    }, [isGroupSet])

    useEffect(() => {

    }, [groupData, selectedGroupVersion, prodOrders, liveOrders])

    useEffect(() => {
        setWishlisted(wishListedItems)
    }, [wishListedItems])

    useEffect(() => {
        if (apiData.link) {
            checkEnvironment(apiData.link);
        }
    }, [apiData.link])

    useEffect(() => {
        document.addEventListener('mousedown', (ev) => {
            const el = document.getElementsByClassName('version-dropdown-list')[0]
            let target: any = ev.target
            if (typeof el === 'undefined') {
                return
            }
            if (el.contains(target)) {
                return
            }
            if (!el.contains(target)) {
                setShowVersionDropdown(false)
            }
        })
    }, [])

    const patchCodeSnippet = (snippet: string = '', details: any, identifier: string) => {
        let patchedSnippet = '';
        if (snippet !== '') {
            patchedSnippet = snippet
                .replace('{{URL}}', `https://sandbox.kfintech.com/${identifier}`)
                .replace('{{BODY}}', JSON.stringify(details.request[0]));
        }
        return patchedSnippet;
    };

    /** Change request and response tab view */
    const onDocTabChange = (type: 'req' | 'res') => {
        if (type === 'req') {
            setDocTab({ requestTab: true, responseTab: false })
        }
        if (type === 'res') {
            setDocTab({ requestTab: false, responseTab: true })
        }

    }

    useEffect(() => {
        handlePagination(groupData);
    }, [selectedGroupVersion, groupData, currentGroupVersionAPIs]);
    const handlePagination = (response: any) => {
        const currentVersion = selectedGroupVersion;
        const currentSelectedVersionData = groupData.group_versions.find((gv: any) => gv.group_version === currentVersion);
        setCurrentVersionData(currentSelectedVersionData);
        if (currentVersionData !== null) {
            setCurrentGroupVersionAPIs(currentVersionData?.apis);
            setCurrentGroupVersionAPIndex(0);
        }
    }

    const getGroupAPIVersionData = (version: string) => {
        if (version === selectedVersion) {
            setShowVersionDropdown(false);
        }
        dispatch(showLoader(message.GETTING_SELECTED_VERSION))
        setSelectedGroupVersion(version);
        const selectedVersionData = groupData.group_versions.find((gv: any) => gv.group_version === version);
        getAPIbyGroupVersionId(selectedVersionData);
        if (selectedVersionData) {
            handleAPISelect(selectedVersionData.apis[0].api_version, 0, groupData.group_id, selectedVersionData.group_version_id);
        }
        setShowVersionDropdown(false);
        setTimeout(() => {
            dispatch(hideLoader())
        }, 500)
    }


    const handleAddCart = async (group: any, currentGroupVersionData: any) => {
        // Block adding a DEPRECATED version to the cart — but only if the user does
        // NOT already own it (already-bought deprecated versions must keep working).
        if (isDeprecatedBlocked) {
            return;
        }
        if (typeof params.apiID !== 'undefined' && location.state !== null) {
            const isProdFlow = location.state?.from === NavList.API_LISTING_PRODUCTION ||
                location.state?.source === "prod-orders" ||
                showGoLiveForProcessedUATOrder

            if (location.state?.from === NavList.MARKET_PLACE) {
                if (cartItems.includes(Number(currentVersionData?.group_version_id))) {
                    navigate(NavList.CART)
                    return;
                }
                if (uatOrders.includes(Number(currentVersionData?.group_version_id))) {
                    dispatch(setOrderTab('uat'))
                    navigate(NavList.ORDERS);
                    return;
                }
            }
            // if (isProdFlow) {
                 
            //     if (prodOrders.includes(Number(currentVersionData?.group_version_id))) {
            //         console.log("Adding to production orders");
            //         dispatch(setOrderTab('prod'))
            //         navigate(NavList.ORDERS)
            //         return
            //     }
            // }
            if (location.state?.source === "uat-orders" && !showGoLiveForProcessedUATOrder) {
                if (uatOrders.includes(Number(currentVersionData?.group_version_id))) {
                    dispatch(setOrderTab('uat'))
                    navigate(NavList.ORDERS);
                    return;
                }
            }
            if (isProdFlow) {
                if (prodOrders.includes(Number(currentVersionData.group_version_id))) {
                    dispatch(setOrderTab('prod'))
                    navigate(NavList.ORDERS)
                    return
                }

                if (prodCartItems.includes(Number(currentVersionData.group_version_id))) {
                    dispatch(setSideModalOption('prod'))
                    dispatch(setShowSideModal(true))
                    return;
                }
                //dispatch(setSideModalOption("prod"));
                //dispatch(showLoader(message.ADDING_CHECKOUT));
                const billingResponse = await getDetails(APIList.USER_BILLING_DETAILS, () => handleAddCart(group, currentVersionData.group_version_id))
                dispatch(hideLoader())

                if (billingResponse.statusCode === APIResponseCodes.SUCCESS) {

                    const data = billingResponse.data || {};

                    // 🔍 Treat non-string or empty as "missing"
                    const invalidType =
                        typeof data.billing_address !== "string" ||
                        // typeof data.gstin !== "string" ||
                        // typeof data.pan !== "string" ||
                        typeof data.authorised_signatory !== "string";

                    const isEmpty =
                        !data.billing_address?.trim()?.length ||
                        // !data.gstin?.trim()?.length ||
                        // !data.pan?.trim()?.length ||
                        !data.authorised_signatory?.trim()?.length;

                    if (invalidType || isEmpty) {
                        setBillingForm({
                            billing_address:
                                typeof data.billing_address === "string" ? data.billing_address : "",
                            authorised_signatory:
                                typeof data.authorised_signatory === "string"
                                    ? data.authorised_signatory
                                    : "",
                        });
                        setShowBillingModal(true);
                        return;
                    }
                }
            }

            const payload = { groupId: parseInt(decodeURIComponent(decrypt(params.apiID))), groupVersionId: currentVersionData.group_version_id }

            
            const response = await postDetails(location.state?.from === NavList.MARKET_PLACE ? APIList.SET_CART_ITEM : isProdFlow ? APIList.ADD_TO_PROD_CART : APIList.SET_CART_ITEM, payload, () => handleAddCart(group, currentVersionData.group_version_id))
            if (response?.statusCode === APIResponseCodes.SUCCESS) {
                dispatch(setCartIDs([...cartIDs, response.data]))
                if (isProdFlow) {
                    dispatch(setSideModalOption('prod'))
                    dispatch(setShowSideModal(true))
                    dispatch(setUserCartItems([...cartItems, currentVersionData.group_version_id]))
                    return
                }
                dispatch(setUserCartItems([...cartItems, currentVersionData.group_version_id]))
                navigate(NavList.CART)
            }
        }
    }

    // Handle billing info submission
    const handleBillingSubmit = async (payload: {
        billing_address: string;
        authorised_signatory: string;
    }) => {

        try {
            dispatch(showLoader("Updating billing information..."));
            const response = await postDetails(APIList.USER_SAVE_BILLING_DETAILS, payload
            );

            dispatch(hideLoader());

            if (response.statusCode === APIResponseCodes.SUCCESS) {
                setShowBillingModal(false);
                dispatch(setShowCTAModal(false))
                dispatch(setMessage("Billing information updated successfully."))
                dispatch(setAlertMode(true))
                dispatch(setShowAlert(true))
            } else {
                dispatch(showMessageOnFailure("Failed to update billing information."));
            }
        } catch (err) {
            dispatch(hideLoader());
            console.error(err);
            dispatch(showMessageOnFailure("Failed to update billing information."));
        }
    };

    /** Handle wishlist click */
    const handleWishlist = async (groupData: any) => {
        const el = document.getElementsByClassName('toast-text')[0]
        el.classList.remove('d-block')
        el.classList.remove('d-none')
        if (wishListedItems.includes(currentVersionData.group_version_id)) {
            const response = await postDetails(APIList.REMOVE_FROM_WISHLIST, { groupId: groupData.group_id, groupVersionId: currentVersionData.group_version_id }, () => handleWishlist(groupData))
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                let filtered = wishListedItems.filter((item: any) => item !== currentVersionData.group_version_id)
                dispatch(setWishListedItems(filtered))
                setWishlisted(filtered)
                el.classList.add('d-block')
                setTimeout(() => el.classList.add('d-none'), 2000)
            }
        } else {
            const response = await postDetails(APIList.ADD_TO_WISHLIST, { groupId: groupData.group_id, groupVersionId: currentVersionData.group_version_id }, () => handleWishlist(groupData))
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                dispatch(setWishListedItems([...wishListedItems, response.data.group_version_id]))
                setWishlisted([...wishListedItems, response.data.group_version_id])
                el.classList.add('d-block')
                setTimeout(() => el.classList.add('d-none'), 2000)
            }
        }
    }

    const getListingData = async () => {
        await dispatch(getPageData(APIList.GET_GROUPS + "?search=&page_no=1"))
    }

    const copyToClipboard = async (copyValue: any, type: 'request' | 'response') => {
        const textToCopy = Array.isArray(copyValue) ? JSON.stringify(copyValue, null, 2) : copyValue;

        if (window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(textToCopy);
                if (type === 'request') {
                    setCopyRequest('Copied!!!');
                    setCopyResponse('Copy');
                } else {
                    setCopyResponse('Copied!!!');
                    setCopyRequest('Copy');
                }

                setTimeout(() => {
                    if (type === 'request') {
                        setCopyRequest('Copy');
                    } else {
                        setCopyResponse('Copy');
                    }
                }, 2000);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        } else {
            console.warn('Clipboard API is not available in this context.');
        }
    };

    const handleCopy = (type: string, text: string) => {
        if (type === "link") {
            navigator.clipboard.writeText(text)
                .then(() => {
                    setCopyUrlText('Copied!!!');
                    setTimeout(() => setCopyUrlText('Copy'), 2000);
                })
                .catch(err => {
                    setCopyUrlText('Failed to copy');
                    setTimeout(() => setCopyUrlText('Copy'), 2000);
                });
        }
        if (type === "groupKey") {
            navigator.clipboard.writeText(text)
                .then(() => {
                    setCopyKeyText('Copied!!!');
                    setTimeout(() => setCopyKeyText('Copy'), 2000);
                })
                .catch(err => {
                    setCopyKeyText('Failed to copy');
                    setTimeout(() => setCopyKeyText('Copy'), 2000);
                });
        }
    };

    const getPreviousAPI = () => {
        if (currentGroupVersionAPIndex > 0) {
            const previousAPI = currentGroupVersionAPIs[currentGroupVersionAPIndex - 1];
            handleAPISelect(previousAPI.api_version, currentGroupVersionAPIndex, groupData.group_id, currentVersionData.group_version_id); // Assuming version_id is available in the API object
            setCurrentGroupVersionAPIndex(currentGroupVersionAPIndex - 1);
            setShowResponse(false);
            setResponseContent("");
            setStatusCode(null);
            setStatusHide(true);
        }

    };

    const getNextAPI = () => {
        if (currentGroupVersionAPIndex < currentGroupVersionAPIs?.length - 1) {
            const nextAPI = currentGroupVersionAPIs[currentGroupVersionAPIndex + 1];
            handleAPISelect(nextAPI.api_version, currentGroupVersionAPIndex, groupData.group_id, currentVersionData.group_version_id); // Assuming version_id is available in the API object
            setCurrentGroupVersionAPIndex(currentGroupVersionAPIndex + 1);
            setShowResponse(false);
            setResponseContent("");
            setStatusCode(null);
            setStatusHide(true);
        }
    };

    const handleDownloadPdf = async () => {
    try {
    setisDownload(true)

    if (!printRef.current || !apiDetailsRef.current) return

    window.scrollTo(0, 0)
    await new Promise((resolve) => setTimeout(resolve, 100))

    const pdf = new jsPDF("p", "mm", "a4")
    const pdfWidth = pdf.internal.pageSize.getWidth()
    const pdfHeight = pdf.internal.pageSize.getHeight()
    const marginTop = 10
    const marginBottom = 15
    const marginSide = 10
    const usableWidth = pdfWidth - 2 * marginSide
    const usableHeight = pdfHeight - marginTop - marginBottom

    let currentY = marginTop

    // Capture header
    const headerCanvas = await html2canvas(printRef.current, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: "#cccccc",
      ignoreElements: (el) => el.classList.contains("no-print"),
    })

    const headerImgData = headerCanvas.toDataURL("image/png", 1.0)
    const headerImgWidth = usableWidth
    const headerImgHeight = (headerCanvas.height * usableWidth) / headerCanvas.width

    pdf.addImage(headerImgData, "PNG", marginSide, currentY, headerImgWidth, headerImgHeight)
    currentY += headerImgHeight + 8

    // Capture details section
    const capturedDetailsCanvas = await html2canvas(apiDetailsRef.current, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: "#ffffff",
      ignoreElements: (el) => el.classList.contains("no-print"),
    })

    const canvasContext = capturedDetailsCanvas.getContext("2d")
    if (!canvasContext) throw new Error("Unable to inspect captured API details.")

    let contentHeight = capturedDetailsCanvas.height
    const rowsPerScan = 32
    for (let scanEnd = capturedDetailsCanvas.height; scanEnd > 0;) {
      const scanStart = Math.max(0, scanEnd - rowsPerScan)
      const scanHeight = scanEnd - scanStart
      const pixels = canvasContext.getImageData(
        0,
        scanStart,
        capturedDetailsCanvas.width,
        scanHeight,
      ).data
      let foundContent = false

      for (let row = scanHeight - 1; row >= 0 && !foundContent; row--) {
        for (let column = 0; column < capturedDetailsCanvas.width; column++) {
          const pixelIndex = (row * capturedDetailsCanvas.width + column) * 4
          if (pixels[pixelIndex] < 250 || pixels[pixelIndex + 1] < 250 || pixels[pixelIndex + 2] < 250) {
            contentHeight = Math.min(capturedDetailsCanvas.height, scanStart + row + 5)
            foundContent = true
            break
          }
        }
      }

      if (foundContent) break
      scanEnd = scanStart
    }

    const detailsCanvas = document.createElement("canvas")
    detailsCanvas.width = capturedDetailsCanvas.width
    detailsCanvas.height = contentHeight
    const detailsContext = detailsCanvas.getContext("2d")
    if (!detailsContext) throw new Error("Unable to prepare API details for PDF.")
    detailsContext.drawImage(
      capturedDetailsCanvas,
      0,
      0,
      detailsCanvas.width,
      detailsCanvas.height,
      0,
      0,
      detailsCanvas.width,
      detailsCanvas.height,
    )

    const detailsImgData = detailsCanvas.toDataURL("image/png", 1.0)
    const detailsImgWidth = usableWidth
    const detailsImgHeight = (detailsCanvas.height * usableWidth) / detailsCanvas.width
    const detailsBounds = apiDetailsRef.current.getBoundingClientRect()
    if (detailsBounds.height <= 0) throw new Error("Unable to determine API details dimensions.")
    const canvasScaleY = capturedDetailsCanvas.height / detailsBounds.height
    const tableRowBoundaries = Array.from(
      apiDetailsRef.current.querySelectorAll<HTMLTableRowElement>("tr"),
      (row) => Math.round((row.getBoundingClientRect().bottom - detailsBounds.top) * canvasScaleY),
    )
      .filter((boundary) => boundary > 0 && boundary < contentHeight)
      .sort((a, b) => a - b)

    const spaceLeftOnFirstPage = pdfHeight - currentY - marginBottom

    if (detailsImgHeight <= spaceLeftOnFirstPage) {
      // Everything fits on current page
      pdf.addImage(detailsImgData, "PNG", marginSide, currentY, detailsImgWidth, detailsImgHeight)
    } else {
      // Need to split across pages - crop and add portions
      let remainingImageHeight = detailsCanvas.height
      let canvasSourceY = 0 // Current Y position in source canvas
      let pageIndex = 0

      while (remainingImageHeight > 0) {
        const availableSpace = pageIndex === 0 ? spaceLeftOnFirstPage : usableHeight

        const pixelsToUse = Math.min(
          Math.floor((availableSpace * detailsCanvas.width) / usableWidth),
          remainingImageHeight,
        )
        if (pixelsToUse <= 0) throw new Error("No PDF page space is available for API details.")
        const pageEndLimit = canvasSourceY + pixelsToUse
        const safeRowBoundary = tableRowBoundaries.reduce<number | null>(
          (boundary, rowBoundary) =>
            rowBoundary > canvasSourceY && rowBoundary <= pageEndLimit ? rowBoundary : boundary,
          null,
        )
        const pagePixelsToUse = safeRowBoundary
          ? safeRowBoundary - canvasSourceY
          : pixelsToUse

        // Create cropped canvas from source
        const croppedCanvas = document.createElement("canvas")
        const ctx = croppedCanvas.getContext("2d")
        if (!ctx) throw new Error("Unable to prepare API details page for PDF.")

        croppedCanvas.width = detailsCanvas.width
        croppedCanvas.height = pagePixelsToUse

        // Draw only the portion we need from source canvas
        ctx.drawImage(
          detailsCanvas,
          0,
          canvasSourceY,
          detailsCanvas.width,
          pagePixelsToUse,
          0,
          0,
          detailsCanvas.width,
          pagePixelsToUse,
        )

        // Convert cropped portion to image data
        const croppedImgData = croppedCanvas.toDataURL("image/png", 1.0)
        const croppedHeight = (croppedCanvas.height * usableWidth) / croppedCanvas.width

        // Add to PDF
        const yPos = pageIndex === 0 ? currentY : marginTop
        pdf.addImage(croppedImgData, "PNG", marginSide, yPos, detailsImgWidth, croppedHeight)

        // Update tracking variables
        canvasSourceY += pagePixelsToUse
        remainingImageHeight -= pagePixelsToUse

        // Add new page if there's more content
        if (remainingImageHeight > 0) {
          pdf.addPage()
          pageIndex++
        }
      }
    }

    const fileName = `${groupData.group_name}_v${selectedGroupVersion}_${apiData.name}_documentation.pdf`
      .replace(/\s+/g, "_")
      .replace(/[^a-zA-Z0-9_.-]/g, "")

    pdf.save(fileName)
    setisDownload(false)
  } catch (err) {
    console.error("PDF Generation Error:", err)
    setisDownload(false)
    dispatch(setMessage("Failed to generate PDF. Please try again."))
    dispatch(setAlertMode(false))
    dispatch(setShowAlert(true))
  }
};


    const handleJSONSwitch = (e: any) => {
        const isChecked = e.target.checked;
        if (docTab.requestTab) {
            setShowJSONView((prevState) => ({
                ...prevState,
                requestTab: isChecked,
            }));
        } else if (docTab.responseTab) {
            setShowJSONView((prevState) => ({
                ...prevState,
                responseTab: isChecked,
            }));
        }
    };

    const handleTrackAPI = (groupId: number, groupVersionId: number, id: number) => {
        navigate(`${NavList.LIVE_API_DETAILS}${encodeURIComponent(encrypt(id))}`, {
            state: {
                group_id: groupId,
                group_version_id: groupVersionId,
                group_name: groupData.group_name
            }
        })
    }
    const handleRaiseRequest = (groupId: number, groupVersionId: number, id: number) => {
        setRaiseMeta({ groupId, groupVersionId, id });
        setShowraiseRequestModal(true)
    }
    
const handleRaiseSubmit = async (data: { message: string; file: File | null; groupId?: number; groupVersionId?: number; id?: number }) => {
  try {
    dispatch(showLoader(message.SUBMIT_REQUEST || "Submitting request..."));


    // Build form data
    const formData = new FormData();

    const payload = {
      message: data.message,
    //   group_id: data.groupId,
      group_version_id: data.groupVersionId,
      api_version_id: data.id,
    };
       formData.append("data", encrypt(payload));
    if (data.file) {
      formData.append("files", data.file, data.file.name);
    }

    // // append ids (convert to string)
    // // if (typeof data.groupId !== "undefined") formData.append("group_id", String(data.groupId));
    // if (typeof data.groupVersionId !== "undefined") formData.append("group_version_id", String(data.groupVersionId));
    // if (typeof data.id !== "undefined") formData.append("api_version_id", String(data.id)); // use the key name your backend expects

    // Example API call — replace APIList.RAISE_REQUEST with your endpoint constant
    const response = await postMultipartDetails(APIList.RAISE_REQUEST, formData);
     dispatch(hideLoader());
         if (response && (response.statusCode === APIResponseCodes.SUCCESS || (response.data && response.data.statusCode === APIResponseCodes.SUCCESS))) {
      // navigate to support requests page (keeps behaviour consistent with handleRequest)
      navigate(NavList.SUPPORT_REQUESTS);

      // optionally show success toast/alert here
      return response;
    }
        // not success — return response so caller can handle error message
    return response;
    // handle response...

    // for now log
    // console.log("API Response:", response);

    // close modal on success
    setShowraiseRequestModal(false);
  } catch (err) {
    // handle error
        dispatch(hideLoader());

    console.error(err);
  }
};

const extractBodyForEditor = (code: any) => {
  // Always make sure we have a STRING
  const codeString = typeof code === 'string' ? code : code?.toString ? code.toString() : '';

  // Extract body: JSON.stringify(...)
  const bodyMatch = codeString.match(/body\s*:\s*JSON\.stringify\(([\s\S]*?)\)/);
  let editorText = '';

  //If body found
  if (bodyMatch && bodyMatch[1]) {
    try {
      // Try parsing JSON inside stringify
      const bodyObject = JSON.parse(bodyMatch[1]);

      // Ace Editor needs STRING
      editorText = JSON.stringify(bodyObject, null, 2);
    } catch (err) {
      // If JSON is invalid, fallback to raw string
      editorText = bodyMatch[1];
    }
  } else {
    // If no body found, show full code
    editorText = codeString;
  }

  //FINAL SAFETY: Ace Editor always gets string
  return typeof editorText === 'string' ? editorText : String(editorText);
};

const handleDownloadPostman = async () => {
    if (!currentVersionData?.group_version_id || !apiEnvironment) return;
    try {
      dispatch(showLoader("Downloading Postman collection..."));
      const payload = {
        group_version_id: currentVersionData.group_version_id,
        api_env: apiEnvironment.toLowerCase(),
      };
      const response = await postDetails(APIList.DOWNLOAD_POSTMAN_COLLECTION, payload);
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        const blob = new Blob([JSON.stringify(response.data, null, 2)], {
          type: "application/json",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${groupData.group_name}_v${selectedGroupVersion}_postman_collection.json`.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_.-]/g, "");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else {
        dispatch(showMessageOnFailure("Failed to download Postman collection."));
      }
    } catch (err) {
      console.error(err);
      dispatch(showMessageOnFailure("Failed to download Postman collection."));
    } finally {
      dispatch(hideLoader());
    }
  };

  const showGoLiveForProcessedUATOrder =
  location.state?.source === 'uat-orders' && location.state?.uatOrderProcessed;

  // Whether the currently selected version is already owned/in-progress by the user.
  // Deprecation must NOT affect versions the user already bought or has in cart.
  // Match against both the numeric and raw value to avoid string/number mismatches
  // across the various order/cart arrays.
  const isVersionOwned = (() => {
    if (!currentVersionData) return false;
    const rawId = currentVersionData.group_version_id;
    const numId = Number(rawId);
    const owns = (arr: any[]) =>
      Array.isArray(arr) &&
      (arr.includes(numId) || arr.includes(rawId) || arr.map(Number).includes(numId));
    return (
      owns(cartItems) ||
      owns(prodCartItems) ||
      owns(uatOrders) ||
      owns(prodOrders) ||
      owns(liveOrders)
    );
  })();

  // Block cart actions only when the selected version is deprecated AND not already owned.
  const isDeprecatedBlocked =
    !!currentVersionData?.is_deprecated && !isVersionOwned;

// const handleDownloadOnboarding  = async () => {    
//     // if (!apiData?.ap_ver_id || !apiEnvironment) return;
//     if (!apiData?.ap_ver_id) return;
//     try {
//       dispatch(showLoader("Downloading API onboarding document..."));
//       const payload = {
//         // group_version_id: currentVersionData.group_version_id,
//         // api_env: apiEnvironment.toLowerCase(),
//         apiVersionId: apiData?.ap_ver_id,
//         // api_env: apiEnvironment.toLowerCase(),
//       };
//       const response = await postDetailsBlob(APIList.DOWNLOAD_ONBOARDING_DOCUMENT, payload);
//       if (response.status === 200) {
//         const contentType = response.headers?.["content-type"] || "application/pdf";
//         const blob = new Blob([response.data], {
//           type: contentType,
//         });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = `${groupData.group_name}_v${selectedGroupVersion}_onboarding_document.pdf`.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_.-]/g, "");
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);
//         URL.revokeObjectURL(url);
//       } else {
//         dispatch(showMessageOnFailure("Failed to download API onboarding document."));
//       }
//     } catch (err) {
//       console.error(err);
//       dispatch(showMessageOnFailure("Failed to download API onboarding document."));
//     } finally {
//       dispatch(hideLoader());
//     }
//   };
    return (
        <MainContainer>
            <Breadcrumb routes={[...BreadcrumbData.group_details, { id: `${Date.now()}`, routeLabel: groupData.group_name, route: '' }]} callbackFunc={getListingData} />
            <div className="mf-active-header-padding">
                <div className='mf-api-details bg-white' >
                    <div className="api-details-container">
                        {
                            location.state !== null &&
                            location.state?.from === NavList.ORDERS &&
                            location.state?.status?.length !== 0 &&
                            <div className="p-3">
                                <InfoCard message={location.state.remark} status={location.state.status} />
                            </div>
                        }
                        {isDownload && <div className="d-flex align-items-start justify-content-between px-3 pt-3" ref={printRef}>
                            <div>
                                <div className='row'>
                                    <p className="mb-0 text-sec-color weight-600 text-capitalize">{groupData.group_name}</p>
                                    <p className="mb-0 text-sec-color weight-400 text-capitalize">{apiData.name}</p>
                                </div>
                                <p className="mb-0 text-sec-color weight-600 text-capitalize">{selectedGroupVersion}</p><br />
                                <small className='font-13 weight-500 text-capitalize'>{groupData.group_type}</small>

                            </div>
                            <div className="api-dev-status">
                                <img width={64} height={64} src={prodIcon} alt="production" />
                            </div>
                        </div>}
                        <div className="d-flex align-items-start justify-content-between px-3 py-3" >
                            <div className="api-dev-status d-flex align-items-center gap-2">
                                <img width={64} height={64} src={prodIcon} alt="production" />
                                <div className="api-basic-texts py-1 px-3">
                                    <div className="api-basic-texts-header d-flex">
                                        <p className="mb-0 text-sec-color weight-600 text-capitalize">{groupData.group_name}</p>
                                        <div className="version-dropdown position-relative">

                                            <button onClick={() => setShowVersionDropdown(!showVersionDropdown)} type='button' className='weight-500 text-uppercase font-14 text-sec-color version-dropdown-btn text-start'>
                                                {groupVersions.length > 0 ? `V ${selectedGroupVersion}` : `select Version`}
                                            </button>
                                            <ul className={showVersionDropdown ? "version-dropdown-list no-list-style py-2 mb-0 bg-white ps-0 custom-scrollbar" : "d-none"}>
                                                {groupVersions.map((version, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => getGroupAPIVersionData(version)}
                                                        className='weight-500 text-uppercase text-primary-color py-1 px-3 version-dropdown-list-item'>
                                                        V {version.length === 1 ? `${version}.0` : version}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        {isDeprecatedBlocked && (
                                            <div className="deprecated-version-note ms-2 px-2 py-1">
                                                This version has been deprecated, kindly check for the other versions.
                                            </div>
                                        )}
                                    </div>
                                    <small className='font-13 weight-500 text-capitalize'>{groupData?.group_type?.toLowerCase() === 'e-cas'? 'Read Only' : groupData?.group_type}</small>
                                </div>
                            </div>
                           <div className="d-flex align-items-center">
                {/* Download Postman Collection */} 
                {(apiEnvironment === "UAT" || apiEnvironment === "PROD") && currentVersionData && (
                  <OverlayTrigger placement="top" overlay={<Tooltip>Download Postman Collection</Tooltip>}>
                    <div onClick={handleDownloadPostman} className="mf-api-download-option cursor-pointer me-3" />
                  </OverlayTrigger>
                )}
                {/* Download API onboarding document */} 
                {/* { currentVersionData && (
                  <OverlayTrigger placement="top" overlay={<Tooltip>Download API Onboarding Document</Tooltip>}>
                    <div onClick={handleDownloadOnboarding} className="mf-api-download-option cursor-pointer me-3" />
                  </OverlayTrigger>
                )} */}
                {/* Wishlist */}
                <OverlayTrigger placement="top" overlay={<Tooltip>{wishlisted.includes(currentVersionData?.group_version_id) ? "Remove from Wishlist" : "Add to Wishlist"}</Tooltip>}>
                  <div
                    onClick={() => handleWishlist(groupData)}
                    data-selected={wishlisted.includes(currentVersionData?.group_version_id)}
                    className="api-wishlist cursor-pointer mf-api-wishlist-option me-3 position-relative"
                  >
                    <div className="toast-text text-white font-13 px-3 py-1 d-none">{wishlisted.includes(currentVersionData?.group_version_id) ? "Added to wishlist." : "Removed from wishlist."}</div>
                  </div>
                </OverlayTrigger>
 
 
                {/* Share */}
                <OverlayTrigger placement="top" overlay={<Tooltip>Share</Tooltip>}>
                  <div onClick={() => setShowShare(true)} className="api-share cursor-pointer mf-api-share-option" />
                </OverlayTrigger>
               
              </div>
                        </div>

                        <div className="mt-2 mb-4 d-block d-md-none d-lg-none px-3">
                            {
                                location.state !== null && currentVersionData &&
                                <div className="api-details-cart-btn d-block d-md-none d-lg-none">
                                    {
                                        [...liveOrders].includes(currentVersionData.group_version_id) || location.state?.from === NavList.API_LISTING_LIVE ?
                                            (
                                                <div className='button-container'>
                                                <CustomButton onClick={() => handleTrackAPI(groupData.group_id, currentVersionData.group_version_id, parseInt(apiData.ap_ver_id))}>
                                                    Track API
                                                </CustomButton>
                                                <CustomButton onClick={() => handleRaiseRequest(groupData.group_id, currentVersionData.group_version_id, parseInt(apiData.ap_ver_id))}>
                                                    Raise Request
                                                </CustomButton>
                                                </div>
                                            ) :
                                            (
                                                <>
                                                    {
                                                        access.hasUATAccess && (location.state?.from === NavList.MARKET_PLACE || location.state?.source === 'uat-orders' && !showGoLiveForProcessedUATOrder) &&
                                                        <CustomButton className={isDeprecatedBlocked ? 'deprecated-cart-btn' : ''} disabled={isDeprecatedBlocked} onClick={() => handleAddCart(groupData, currentVersionData.group_version_id)}>
                                                            {
                                                                cartItems.includes(currentVersionData.group_version_id) ? "View in Cart"
                                                                    :
                                                                    uatOrders.includes(currentVersionData.group_version_id) ? 'View order' : "Add to Cart"
                                                            }
                                                        </CustomButton>
                                                    }
                                                    {
                                                        access.hasProdAccess && (location.state?.from === NavList.API_LISTING_PRODUCTION || location.state?.source === 'prod-orders' || showGoLiveForProcessedUATOrder) &&
                                                        <CustomButton className={isDeprecatedBlocked ? 'deprecated-cart-btn' : ''} disabled={isDeprecatedBlocked} onClick={() => handleAddCart(groupData, currentVersionData.group_version_id)}>
                                                            {
                                                                prodCartItems.includes(currentVersionData.group_version_id) ? "View in Cart"
                                                                    :
                                                                    prodOrders.includes(currentVersionData.group_version_id) ? 'View order' : "Go live"
                                                            }
                                                        </CustomButton>
                                                    }
                                                </>
                                            )
                                    }
                                </div>
                            }
                        </div>
                        <div className='row ms-0' style={{ minHeight: 'calc(100vh - 200px)' }}>
                            <div className='col-2 bg-left-panel mt-2 px-0'>
                                <div className="panel-header">
                                    APIs
                                </div>
                                <ul className="api-list text-white">
                                    {
                                        groupVersionAPIs.map((api: any, index: number) => (
                                            <li key={index} onClick={() => handleAPISelect(api.api_version, index, groupData.group_id, currentVersionData.group_version_id)}
                                                className={`cursor-pointer lh-sm py-2 text-wrap text-center w-100 lable-side sidenav-hover ${index === currentGroupVersionAPIndex ? 'active-api' : ''}`}
                                            >
                                                <span className="px-1 mb-0 text-capitalize text-white sidenav-lable">
                                                    {api.api_name}
                                                </span>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                            <div className='col-10'>
                                <div className="api-details-tabs d-flex align-items-end justify-content-between px-3 ps-0">
                                    <div className="d-flex">
                                        <button onClick={() => setIsAPIInfoActive(1)} type='button' className={isAPIInfoActive === 1 ? "api-details-tab-btn-active api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0" : "api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0"}>API Info</button>
                                        <button onClick={() => setIsAPIInfoActive(2)} type='button' className={isAPIInfoActive === 2 ? "api-details-tab-btn-active api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0" : "api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0"}>Documentation</button>
                                        <button onClick={() => { setIsAPIInfoActive(3); setIsRunClicked(false); }} type='button' className={isAPIInfoActive === 3 ? "api-details-tab-btn-active api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0" : "api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0"}>Try It Out</button>
                                    </div>
                                    {
                                        location.state !== null && currentVersionData &&
                                        <div className="api-details-cart-btn d-none d-md-block d-lg-block">

                                            {[...liveOrders].includes(currentVersionData.group_version_id) || location.state?.from === NavList.API_LISTING_LIVE ? (
                                                <div className='button-container'>
                                                <CustomButton onClick={() => handleTrackAPI(groupData.group_id, currentVersionData.group_version_id, parseInt(apiData.ap_ver_id))}>
                                                    Track API
                                                </CustomButton>
                                                <CustomButton onClick={() => handleRaiseRequest(groupData.group_id, currentVersionData.group_version_id, parseInt(apiData.ap_ver_id))}>
                                                    Raise Request
                                                </CustomButton>
                                                </div>
                                            ) :
                                                (
                                                    <>
                                                        {
                                                            access.hasUATAccess && (location.state?.from === NavList.MARKET_PLACE || location.state?.source === 'uat-orders' && !showGoLiveForProcessedUATOrder) &&
                                                            <CustomButton className={isDeprecatedBlocked ? 'deprecated-cart-btn' : ''} disabled={isDeprecatedBlocked} onClick={() => handleAddCart(groupData, currentVersionData.group_version_id)}>
                                                                {
                                                                    cartItems.includes(currentVersionData.group_version_id) ? "View in Cart"
                                                                        :
                                                                        uatOrders.includes(currentVersionData.group_version_id) ? 'View order' : "Add to Cart"
                                                                }
                                                            </CustomButton>
                                                        }
                                                        {
                                                            access.hasProdAccess && (location.state?.from === NavList.API_LISTING_PRODUCTION || location.state?.source === 'prod-orders' || showGoLiveForProcessedUATOrder) &&
                                                            <CustomButton className={isDeprecatedBlocked ? 'deprecated-cart-btn' : ''} disabled={isDeprecatedBlocked} onClick={() => handleAddCart(groupData, currentVersionData.group_version_id)}>
                                                                {
                                                                    prodCartItems.includes(currentVersionData.group_version_id) ? "View in Cart"
                                                                        :
                                                                        prodOrders.includes(currentVersionData.group_version_id) ? 'View order' : "Go live"
                                                                }
                                                            </CustomButton>
                                                        }
                                                    </>
                                                )
                                            }
                                        </div>
                                    }
                                </div>

                                {
                                    isAPIInfoActive === 1 &&
                                    <div className="api-details-main px-3 py-4 ps-0">
                                        {
                                            apiData.link.length !== 0 && (access.hasProdAccess || access.hasUATAccess) && 
                                            <div className='row d-flex align-items-center justify-content-between mt-4'>
                                                <div className='col-12 col-md-6 mb-2 mb-md-0'>
                                                    {apiEnvironment !== null && <p className='mb-0 font-12 weight-500'>{`${apiEnvironment} URL`}</p>}
                                                    <div className="input-group  mb-1 position-relative">
                                                        <input type="text" className="form-control border-color-input  rounded font-12 weight-500 py-2" readOnly
                                                            value={apiData.link}
                                                            style={{ pointerEvents: 'none' }} />
                                                        <button className="copy-btn rounded " type="button"><span className='font-12 me-1' onClick={() => handleCopy("link", apiData.link)}>
                                                            {copyUrlText}
                                                        </span>  <img width={10} height={10} className="icon-white" src={copylink} alt="add" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            currentVersionData && currentVersionData?.group_key !== null && (access.hasProdAccess || access.hasUATAccess) &&
                                            <div className='row d-flex align-items-center justify-content-between mt-4 mb-4'>
                                                <div className='col-12 col-md-6 mb-2 mb-md-0'>
                                                    <p className='mb-0 font-12 weight-500'>Group Key</p>
                                                    <div className="input-group  mb-1 position-relative">
                                                        <input type="text" className="form-control border-color-input  rounded font-12 weight-500 py-2" readOnly
                                                            value={currentVersionData.group_key}
                                                            style={{ pointerEvents: 'none' }} />
                                                        <button className="copy-btn rounded " type="button"><span className='font-12 me-1' onClick={() => handleCopy("groupKey", currentVersionData.group_key)}>
                                                            {copyKeyText}
                                                        </span>  <img width={10} height={10} className="icon-white" src={copylink} alt="add" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className='api-info-bg p-2'>
                                        <div className="api-details-main-info" dangerouslySetInnerHTML={{ __html: apiData?.api_info }} />
                                        </div>

                                        

                                    </div>
                                }

                                {
                                    isAPIInfoActive === 2 && (!access.hasUATAccess && !access.hasProdAccess) &&
                                    <div className="text-center py-5 mx-3">
                                        <p className="mb-0 font-13 weight-500 primary-text-color no-req-params-msg py-4">Documentation access denied...</p>
                                    </div>
                                }

                                {
                                    isAPIInfoActive === 2 && 
                                    (access.hasUATAccess || access.hasProdAccess) &&
                                    <div className="api-details-main px-3 py-4" ref={apiDetailsRef}>
                                        {!isDownload && <div className="api-req-res-btns d-flex align-items-center justify-content-between">
                                            <button onClick={() => onDocTabChange('req')} data-focused={docTab.requestTab} className="req-res-btn text-capitalize font-13 weight-400">request</button>
                                            <button onClick={() => onDocTabChange('res')} data-focused={docTab.responseTab} className="req-res-btn text-capitalize font-13 weight-400">response</button>
                                        </div>}
                                        {
                                            (docTab.requestTab === true || isDownload) &&
                                            <div>
                                                {
                                                    requiredPresent.headers &&
                                                    <div className="mt-4">
                                                        <p className="mb-3 font-14 text-sec-color weight-600 text-capitalize">API Headers</p>
                                                        <div className="mb-2">
                                                            <MFTable tableData={apiData.headers} headerData={tableKeys.headers} />
                                                        </div>
                                                    </div>
                                                }

                                                {
                                                    requiredPresent.params &&
                                                    <div className="mt-4">
                                                        <p className="mb-3 font-14 text-sec-color weight-600 text-capitalize">API URL Parameters</p>
                                                        <div className="mb-2">
                                                            <MFTable tableData={apiData.URLParams} headerData={tableKeys.headers} />
                                                        </div>
                                                    </div>
                                                }

                                                {
                                                    requiredPresent.request ?
                                                        <div className="mt-4">
                                                            <div className="d-flex justify-content-between">
                                                                <p className="mb-3 font-14 text-sec-color weight-600 text-capitalize">API Request details</p>
                                                                {!isDownload && <div className="d-flex align-items-center">
                                                                    <p className="mb-0 text-uppercase text-sec-color weight-400 font-16 me-2 mt-1">JSON</p>
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id="jsonSwitch"
                                                                        className='json-switch'
                                                                        onChange={handleJSONSwitch}
                                                                        checked={docTab.requestTab ? showJSONView.requestTab : showJSONView.responseTab}
                                                                    />
                                                                </div>}
                                                            </div>
                                                            {!showJSONView.requestTab && <Table className='mf-table' responsive>
                                                                <thead className='mf-table-head '>
                                                                    <tr className='mf-table-head-row '>
                                                                        <td className='font-13 weight-500  text-capitalize'>Input</td>
                                                                        <td className='font-13 weight-500 text-capitalize'>Data Type</td>
                                                                        <td className='font-13 weight-500 text-capitalize'>Value</td>
                                                                        <td className='font-13 weight-500 text-capitalize'>Mandatory</td>
                                                                        <td className='font-13 weight-500 text-capitalize'>Description</td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className='mf-table-body'>
                                                                    {apiData.request_params?.length > 0 ? (
                                                                        apiData.request_params.map((param: any, index: any) => (
                                                                            <tr key={index} className='mf-table-body-row'>
                                                                                <td className='font-13 weight-400'>{param.key}</td>
                                                                                <td className='font-13 weight-400'>{param.type}</td>
                                                                                <td className='font-13 weight-400'>
                                                                                    {Array.isArray(param.value) ? (
                                                                                        JSON.stringify(param.value).length > 55 ? (
                                                                                            JSON.stringify(param.value).slice(0, 55) + '...'
                                                                                        ) : (
                                                                                            JSON.stringify(param.value)
                                                                                        )
                                                                                    ) : typeof param.value === 'object' && param.value !== null ? (
                                                                                        Object.keys(param.value).length > 55 ? (
                                                                                            Object.keys(param.value).slice(0, 55).join(', ') + '...'
                                                                                        ) : (
                                                                                            Object.keys(param.value).join(', ')
                                                                                        )
                                                                                    ) : (
                                                                                        param.value
                                                                                    )}</td>
                                                                                <td className='font-13 weight-400'>{param?.required ? "true" : "false"}</td>
                                                                                <td className='font-13 weight-400'>{param.description || '-'}</td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan={5} className="font-13 weight-400 text-center">No Data Found</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </Table>}
                                                            {showJSONView.requestTab && <JSONViewer data={apiData.input[0]} />}

                                                        </div>
                                                        :
                                                        <p className="no-req-params-msg mt-4 py-4 text-center primary-text-color font-13 weight-500">Request values are not required for this API.</p>
                                                }
                                            </div>
                                        }
                                        {
                                            (docTab.responseTab === true || isDownload) &&
                                            <div className="mt-4">
                                                <div className="d-flex justify-content-between">
                                                    <p className="mb-3 font-14 text-sec-color weight-600 text-capitalize">API Response details</p>
                                                    {!isDownload && <div className="d-flex align-items-center">
                                                        <p className="mb-0 text-uppercase text-sec-color weight-400 font-16 me-2 mt-1">JSON</p>
                                                        <Form.Check
                                                            type="switch"
                                                            id="jsonSwitch"
                                                            className='json-switch'
                                                            onChange={handleJSONSwitch}
                                                            checked={docTab.requestTab ? showJSONView.requestTab : showJSONView.responseTab}
                                                        />
                                                    </div>}
                                                </div>
                                                {!showJSONView.responseTab && (
                                                    <Table className="mf-table" responsive>
                                                        <thead className="mf-table-head">
                                                            <tr className="mf-table-head-row">
                                                                <td className="font-13 weight-500 text-capitalize">Input</td>
                                                                <td className="font-13 weight-500 text-capitalize">Data Type</td>
                                                                <td className="font-13 weight-500 text-capitalize">Value</td>
                                                                <td className="font-13 weight-500 text-capitalize">Mandatory</td>
                                                                <td className="font-13 weight-500 text-capitalize">Description</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="mf-table-body">
                                                            {apiData.response_params?.length > 0 ? (
                                                                apiData.response_params.map((param: any, index: any) => 
                                                                {
                                                                    return (
                                                                    <tr key={index} className="mf-table-body-row">
                                                                        <td className="font-13 weight-400">{param.key}</td>
                                                                        <td className="font-13 weight-400">{param.type}</td>
                                                                        <td className="font-13 weight-400">
                                                                            {Array.isArray(param.value) ? (
                                                                                JSON.stringify(param.value).length > 55 ? (
                                                                                    JSON.stringify(param.value).slice(0, 55) + '...'
                                                                                ) : (
                                                                                    JSON.stringify(param.value)
                                                                                )
                                                                            ) : typeof param.value === 'object' && param.value !== null ? (
                                                                                Object.keys(param.value).length > 55 ? (
                                                                                    Object.keys(param.value).slice(0, 55).join(', ') + '...'
                                                                                ) : (
                                                                                    Object.keys(param.value).join(', ')
                                                                                )
                                                                            ) : (
                                                                                param.value
                                                                            )}
                                                                        </td>
                                                                        <td className="font-13 weight-400">{param?.required ? "true" : "false"}</td>
                                                                        <td className="font-13 weight-400">{param.description || '-'}</td>
                                                                    </tr>
                                                                )}
                                                            )
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={5} className="font-13 weight-400 text-center">No Data Found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                )}


                                                {showJSONView.responseTab && <JSONViewer data={apiData.output[0]} />}
                                            </div>
                                        }
                                        <div className='mt-3'>
                                            <p className="mb-3 font-14 text-sec-color weight-600 text-capitalize">Error Codes</p>
                                            <div className="mb-2 mt-4 error-table">
                                                <Table className='mf-table' responsive>
                                                    <thead className='mf-table-head '>
                                                        <tr className='mf-table-head-row '>
                                                            <td className='font-13 weight-500  text-capitalize'>Category</td>
                                                            <td className='font-13 weight-500 text-capitalize'>Error Message</td>
                                                            <td className='font-13 weight-500 text-capitalize'>Error Code</td>

                                                        </tr>
                                                    </thead>
                                                    <tbody className='mf-table-body'>
                                                        {
                                                        // apiData.errorCodes.length > 0 ? (
                                                        //     apiData.errorCodes.map((error: any, index: any) => (
                                                        //         <tr key={index} className='mf-table-body-row'>
                                                        //             <td className='font-13 w-25 weight-400 '>{error.error_type}</td>
                                                        //             <td className='font-13 w-60 weight-400'>{error.error_description}</td>
                                                        //             <td className='font-13 weight-400'>{error.error_code}</td>
                                                        //         </tr>
                                                        //     ))
                                                        // )
                                                        displayedErrorCodes?.length > 0 ? (
                                                                                    displayedErrorCodes.map((error: any, index: any) => (
                                                                                        <tr key={index} className='mf-table-body-row'>
                                                                                            <td className='font-13 weight-400'>{error.error_type}</td>
                                                                                            <td className='font-13 weight-400'>{error.error_description}</td>
                                                                                            <td className='font-13 weight-400'>{error.error_code}</td>
                                                                                        </tr>
                                                                                    ))
                                                                                )
                                                         : (
                                                            <tr>
                                                                <td colSpan={3} className="font-13 weight-400 text-center">No Data Found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                                {!isDownload && apiData.errorCodes?.length > errorCodesPageSize && (
                                                                            <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                    onClick={() => setErrorCodesPage(prev => Math.max(1, prev - 1))}
                                                                                    disabled={errorCodesPage === 1}
                                                                                >
                                                                                    Previous
                                                                                </button>
                                                                                {(() => {
                                                                                    const totalPages = Math.ceil(apiData.errorCodes.length / errorCodesPageSize);
                                                                                    const pages = [];
                                                                                    if (totalPages <= 5) {
                                                                                        for (let i = 1; i <= totalPages; i++) pages.push(i);
                                                                                    } else {
                                                                                        if (errorCodesPage <= 3) {
                                                                                            pages.push(1, 2, 3, '...', totalPages);
                                                                                        } else if (errorCodesPage >= totalPages - 2) {
                                                                                            pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
                                                                                        } else {
                                                                                            pages.push(1, '...', errorCodesPage, '...', totalPages);
                                                                                        }
                                                                                    }
                                                                                    return pages.map((page, idx) => 
                                                                                        page === '...' ? (
                                                                                            <span key={`ellipsis-${idx}`} className="mx-1">...</span>
                                                                                        ) : (
                                                                                            <button
                                                                                                key={page}
                                                                                                className={`btn btn-sm ${errorCodesPage === page ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                                                onClick={() => setErrorCodesPage(page as number)}
                                                                                            >
                                                                                                {page}
                                                                                            </button>
                                                                                        )
                                                                                    );
                                                                                })()}
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                    onClick={() => setErrorCodesPage(prev => Math.min(Math.ceil(apiData.errorCodes.length / errorCodesPageSize), prev + 1))}
                                                                                    disabled={errorCodesPage === Math.ceil(apiData.errorCodes.length / errorCodesPageSize)}
                                                                                >
                                                                                    Next
                                                                                </button>
                                                                            </div>
                                                                        )}

                                            </div>
                                        </div>
                                        <div className="row justify-content-center align-items-center mt-5 ">

                                            <div className="col-2 no-print">
                                                <CustomButton onClick={handleDownloadPdf} theme="primary" size="sm"  >
                                                    {isDownload ? 'Download' : 'Preview'}
                                                </CustomButton>
                                            </div>
                                        </div>

                                    </div>
                                }

                                {isAPIInfoActive === 3 && !isRunClicked && (access.hasUATAccess || access.hasProdAccess) && (
                                    <div>
                                        <div className="px-md-3 py-md-4 px-3 mb-2 mb-md-0">
                                            <div>
                                                <div className="dropdown">
                                                    <button
                                                        className="btn btn-secondary-custom col-4 width-custom py-2 d-flex align-items-center justify-content-between dropdown-toggle"
                                                        type="button"
                                                        id="dropdownMenuButton"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded={true}
                                                    >
                                                        <span className="text-capitalize  usecase-color weight-400">
                                                            {selectedUseCase
                                                                ? useCases.find((item: any) => item.id === selectedUseCase)?.use_case
                                                                : "Please select"}
                                                        </span>
                                                    </button>


                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <div className="dropdown-menu-scroll-usecase">
                                                            {useCases && useCases.length > 0 ? (
                                                                useCases.map((item: any, index: any) => (
                                                                    <li key={index} className="dropdown-item-container">
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => {
                                                                                getDataAccordingUseCase(item.api_id, item.id);
                                                                                if (statusHide) {
                                                                                    setStatusHide(false);
                                                                                }
                                                                            }}
                                                                        >
                                                                            {item.use_case}
                                                                        </button>
                                                                    </li>
                                                                ))
                                                            ) : (
                                                                <li>
                                                                    <button className="dropdown-item" disabled>
                                                                        No Data Found
                                                                    </button>
                                                                </li>
                                                            )}
                                                        </div>
                                                    </ul>


                                                </div>
                                            </div>
                                        </div>

                                        <div className='row row-padding'>


                                            <div className='col-12  '>
                                                <div className="api-details-main px-3 py-1 active-background-color">
                                                    <div className="d-flex">
                                                        <button onClick={() => setIsTryItOutActive(1)} type='button' className={isTryItOutActive === 1 ? "api-details-tab-btn-active api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0" : "api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0"}>Body Params</button>
                                                        <button onClick={() => setIsTryItOutActive(2)} type='button' className={isTryItOutActive === 2 ? "api-details-tab-btn-active api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0" : "api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0"}>Headers</button>
                                                        <button onClick={() => { setIsTryItOutActive(3); setIsRunClicked(false); }} type='button' className={isTryItOutActive === 3 ? "api-details-tab-btn-active api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0" : "api-details-tab-btn text-capitalize border-0 font-14 weight-500 px-0"}>Error Code</button>
                                                    </div>
                                                </div>
                                                <div className='d-flex'>
                                                    <div className='col-8'>
                                                        {isTryItOutActive === 1 && (
                                                            <div className='api-details-main px-2'>
                                                                <div className='mt-3'>
                                                                    <div className="mb-2 mt-4  text-center table-scroll-wrapper">
                                                                        <Table className='mf-table' responsive>
                                                                            <thead className='mf-table-head'>
                                                                                <tr className='mf-table-head-row'>
                                                                                    <td className='font-13 weight-500 text-capitalize'>Parameter Name</td>
                                                                                    <td className='font-13 weight-500 text-capitalize'>Type</td>
                                                                                    <td className='font-13 weight-500 text-capitalize'>Description</td>
                                                                                    <td className='font-13 weight-500 text-capitalize'>Required</td>
                                                                                    <td className='font-13 weight-500 text-capitalize'>Example</td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className='mf-table-body'>
                                                                                {apiData.bodyParams?.length > 0 ? (
                                                                                    apiData.bodyParams.map((param: any, paramIndex: number) => (
                                                                                        <tr key={paramIndex} className='mf-table-body-row'>
                                                                                            <td className='font-13 weight-400'>{param.key}</td>
                                                                                            <td className='font-13 weight-400'>{param.type}</td>
                                                                                            <td className='font-13 weight-400'>{param.description}</td>
                                                                                            <td className='font-13 weight-400'>{param.required ? 'Yes' : 'No'}</td>
                                                                                            <td className='font-13 weight-400'>{JSON.stringify(param.value)}</td>
                                                                                        </tr>
                                                                                    ))
                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={5} className="font-13 weight-400 text-center">
                                                                                            No Request Details Found
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </Table>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        )}
                                                        {isTryItOutActive === 2 && (

                                                            <div className='api-details-main px-1 '>
                                                                <div className="my-3">
                                                                    <p className="mb-3 font-14 text-sec-color weight-600 text-capitalize">Header</p>
                                                                    {apiData.headers?.length > 0 ? (
                                                                        <CodeView
                                                                            copyValue={apiData.headers || null}
                                                                            code={{}}
                                                                            text={JSON.stringify(apiData.headers, null, 2)}
                                                                        />
                                                                    ) : (
                                                                        <CodeView
                                                                            copyValue={null}
                                                                            code={{}}
                                                                            text="No header data available."
                                                                            showdropDownButton={false}
                                                                            showRunButton={false}
                                                                        />
                                                                    )}
                                                                </div>

                                                            </div>
                                                        )}
                                                        {isTryItOutActive === 3 && (
                                                            <div className='api-details-main px-1 '>
                                                                <div className=''>

                                                                    <div className="mb-2 mt-4  text-center">
                                                                        <Table className='mf-table' responsive>
                                                                            <thead className='mf-table-head'>
                                                                                <tr className='mf-table-head-row'>
                                                                                    <td className='font-13 weight-500 text-capitalize'>Category</td>
                                                                                    <td className='font-13 weight-500 text-capitalize'>Error Message</td>
                                                                                    <td className='font-13 weight-500 text-capitalize'>Error Code</td>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className='mf-table-body'>

                                                                                {displayedErrorCodes?.length > 0 ? (
                                                                                    displayedErrorCodes.map((error: any, index: any) => (
                                                                                        <tr key={index} className='mf-table-body-row'>
                                                                                            <td className='font-13 weight-400'>{error.error_type}</td>
                                                                                            <td className='font-13 weight-400'>{error.error_description}</td>
                                                                                            <td className='font-13 weight-400'>{error.error_code}</td>
                                                                                        </tr>
                                                                                    ))
                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={5} className="font-13 weight-400 text-center">No Data Found</td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </Table>
                                                                        {!isDownload && apiData.errorCodes?.length > errorCodesPageSize && (
                                                                            <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                    onClick={() => setErrorCodesPage(prev => Math.max(1, prev - 1))}
                                                                                    disabled={errorCodesPage === 1}
                                                                                >
                                                                                    Previous
                                                                                </button>
                                                                                {(() => {
                                                                                    const totalPages = Math.ceil(apiData.errorCodes.length / errorCodesPageSize);
                                                                                    const pages = [];
                                                                                    if (totalPages <= 5) {
                                                                                        for (let i = 1; i <= totalPages; i++) pages.push(i);
                                                                                    } else {
                                                                                        if (errorCodesPage <= 3) {
                                                                                            pages.push(1, 2, 3, '...', totalPages);
                                                                                        } else if (errorCodesPage >= totalPages - 2) {
                                                                                            pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
                                                                                        } else {
                                                                                            pages.push(1, '...', errorCodesPage, '...', totalPages);
                                                                                        }
                                                                                    }
                                                                                    return pages.map((page, idx) => 
                                                                                        page === '...' ? (
                                                                                            <span key={`ellipsis-${idx}`} className="mx-1">...</span>
                                                                                        ) : (
                                                                                            <button
                                                                                                key={page}
                                                                                                className={`btn btn-sm ${errorCodesPage === page ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                                                onClick={() => setErrorCodesPage(page as number)}
                                                                                            >
                                                                                                {page}
                                                                                            </button>
                                                                                        )
                                                                                    );
                                                                                })()}
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                    onClick={() => setErrorCodesPage(prev => Math.min(Math.ceil(apiData.errorCodes.length / errorCodesPageSize), prev + 1))}
                                                                                    disabled={errorCodesPage === Math.ceil(apiData.errorCodes.length / errorCodesPageSize)}
                                                                                >
                                                                                    Next
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <ul className="nav mt-5 justify-content-center align-items-center flex-md-row flex-column">
                                                            <li className="nav-item me-md-5 mb-2 mb-md-0">
                                                                <a
                                                                    className={`nav-link active font-12 tab-style weight-600 ${currentGroupVersionAPIndex === 0 ? 'disabled' : ''}`}
                                                                    aria-current="page"
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        getPreviousAPI();
                                                                    }}
                                                                >
                                                                    <img
                                                                        width={12}
                                                                        height={12}
                                                                        className={`me-2 mb-1 ${currentGroupVersionAPIndex === 0 ? 'disabled-icon' : ''}`}
                                                                        src={leftArrow}
                                                                        alt="previous"
                                                                    />
                                                                    <span>Previous API</span>
                                                                </a>
                                                            </li>

                                                            <li className="nav-item ms-md-5 mb-2 mb-md-0">
                                                                <a
                                                                    className={`nav-link active font-12 tab-style weight-600 ${currentGroupVersionAPIndex === currentGroupVersionAPIs?.length - 1 ? 'disabled' : ''}`}
                                                                    aria-current="page"
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        getNextAPI();
                                                                    }}
                                                                >
                                                                    <span>Next API</span>
                                                                    <img
                                                                        width={12}
                                                                        height={12}
                                                                        className={`ms-2 mb-1 ${currentGroupVersionAPIndex === currentGroupVersionAPIs?.length - 1 ? 'disabled-icon' : ''}`}
                                                                        src={rightArrow}
                                                                        alt="next"
                                                                    />
                                                                </a>
                                                            </li>
                                                        </ul>

                                                    </div>

                                                    <div className='col-4 border-start'>
                                                        <div className='border-bottom'>
                                                            <div className="mb-3 mx-2 height">
                                                                <p className="mb-0 mt-1 font-14 text-sec-color weight-600 text-capitalize">Request</p>
                                                                <header className="CodeSnippet-header pt-1 pb-1 ">
                                                                    <div className=" text-end pe-2">
                                                                        <button onClick={() => copyToClipboard(extractBodyForEditor(apiData.requestCode), 'request')} type='button' className='btn btn-secondary btn-sm  ms-2 node-dropdown-btn border-0 text-capitalize text-white font-14 weight-400'>{copyRequest}<img width={10} height={10} className="icon-white ms-1" src={copylink} alt="add" /></button>

                                                                        <div className="btn-group custom-drop ">
                                                                            <button className="btn btn-secondary btn-sm dropdown-toggle ms-2 node-dropdown-btn border-0 text-capitalize text-white font-14 weight-400" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                <span className='font-12'>{selectedLanguage}</span>

                                                                            </button>
                                                                            <ul className="dropdown-menu dropdown-menu-custom py-0 " aria-labelledby="dropdownMenuLink">
                                                                                <li><a className="dropdown-item " onClick={(e) => { e.preventDefault(); handleSelectLanguage('Node.js') }} href="#">Node.js</a></li>

                                                                            </ul>
                                                                        </div>


                                                                    </div>
                                                                </header>

                                                                {apiData.requestCode !== '' ? (
                                                                    <div>
                                                                        <AceEditor
                                                                            mode="javascript"
                                                                            theme="monokai"
                                                                            name="code-editor"
                                                                            value={apiData.requestCode ? extractBodyForEditor(apiData.requestCode) : ''}
                                                                            fontSize={11}
                                                                            showPrintMargin={true}
                                                                            showGutter={true}
                                                                            highlightActiveLine={true}
                                                                            wrapEnabled={true}
                                                                            setOptions={{
                                                                                enableBasicAutocompletion: true,
                                                                                enableLiveAutocompletion: true,
                                                                                enableSnippets: true,
                                                                                showLineNumbers: true,
                                                                                tabSize: 2,
                                                                            }}
                                                                            style={{ width: '100%', height: '300px' }}
                                                                            editorProps={{ $blockScrolling: true }}
                                                                            // maxLines={Infinity}
                                                                            scrollMargin={[0, 0, 0, 0]}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <AceEditor
                                                                        mode="javascript"
                                                                        theme="monokai"
                                                                        name="empty-array-editor"
                                                                        value={"No request data available"}
                                                                        fontSize={11}
                                                                        showPrintMargin={true}
                                                                        showGutter={true}
                                                                        highlightActiveLine={true}
                                                                        wrapEnabled={true}
                                                                        setOptions={{
                                                                            enableBasicAutocompletion: true,
                                                                            enableLiveAutocompletion: true,
                                                                            enableSnippets: true,
                                                                            showLineNumbers: true,
                                                                            tabSize: 2,
                                                                        }}
                                                                        style={{ width: '100%', height: '300px' }}
                                                                    />
                                                                )}
                                                                <footer className="CodeSnippet-footer">
                                                                    <div className="run-btn-container pt-1 pb-1">
                                                                        <button type='button' onClick={() => {
                                                                            setShowResponse(true);
                                                                            setResponseContent(JSON.stringify(apiData.response, null, 2));
                                                                            setStatusCode(apiData.status_code);
                                                                            setStatusHide(false);
                                                                        }} className='border-0 px-5 RunButton text-capitalize text-white font-12 py-2 weight-400'>Run</button>
                                                                    </div>

                                                                </footer>
                                                            </div>

                                                        </div>
                                                        <div className="mx-2 height mb-4">

                                                            <p className="mb-0 font-14 text-sec-color weight-600 text-capitalize">Response</p>
                                                            <header className="CodeSnippet-header pt-1 pb-1 d-flex align-item-center justify-content-end pe-3 ">

                                                                {statusHide ? null : (
                                                                    <div className="status-container">
                                                                        {statusCode !== null ? (
                                                                            <div className='d-flex align-items-center'>
                                                                                <div className={`status-circle ${statusCode === 200 ? "status-success" : "status-danger"}`}></div>
                                                                                <span className=' font-13 weight-400 text-white'>
                                                                                    {statusCode}
                                                                                </span>
                                                                            </div>

                                                                        ) : null}
                                                                        <div>
                                                                            <button onClick={() => copyToClipboard(apiData.response, 'response')} type='button' className='btn btn-secondary btn-sm  ms-2 node-dropdown-btn border-0 text-capitalize text-white font-14 weight-400'>{copyResponse}<img width={10} height={10} className="icon-white ms-1" src={copylink} alt="add" /></button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </header>

                                                            <div>
                                                                {showResponse ? (
                                                                    <AceEditor
                                                                        mode="javascript"
                                                                        theme="monokai"
                                                                        name="response-editor"
                                                                        value={responseContent || ''}
                                                                        fontSize={11}
                                                                        showPrintMargin={true}
                                                                        showGutter={true}
                                                                        highlightActiveLine={true}
                                                                        wrapEnabled={true}
                                                                        setOptions={{
                                                                            enableBasicAutocompletion: true,
                                                                            enableLiveAutocompletion: true,
                                                                            enableSnippets: true,
                                                                            showLineNumbers: true,
                                                                            tabSize: 2,
                                                                        }}
                                                                        style={{ width: '100%', height: '300px' }}
                                                                    />
                                                                ) : (
                                                                    <AceEditor
                                                                        mode="javascript"
                                                                        theme="monokai"
                                                                        name="empty-array-editor"
                                                                        value={initialContent}
                                                                        fontSize={11}
                                                                        showPrintMargin={true}
                                                                        showGutter={true}
                                                                        highlightActiveLine={true}
                                                                        wrapEnabled={true}
                                                                        setOptions={{
                                                                            enableBasicAutocompletion: true,
                                                                            enableLiveAutocompletion: true,
                                                                            enableSnippets: true,
                                                                            showLineNumbers: true,
                                                                            tabSize: 2,
                                                                        }}
                                                                        style={{ width: '100%', height: '300px' }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {
                                    isAPIInfoActive === 3 && (!access.hasUATAccess && !access.hasProdAccess) &&
                                    <div className="text-center py-5 mx-3">
                                        <p className="mb-0 font-13 weight-500 primary-text-color no-req-params-msg py-4">Try It Out access denied...</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pt-5 my-5 width-75 mx-auto">
                    <h2 className='font-26 weight-700 text-sec-color text-center mb-4 pb-2'>FAQ's</h2>
                    <FAQ FAQData={faqData} />
                </div>
            </div>
            <Share route='api' show={showShare} callback={() => { setShowShare(false) }} id={`${decodeURIComponent(decrypt(params.apiID))}`} apiGroupName={groupData.group_name} />
            <BillingInfoModal
                show={showBillingModal}
                onClose={() => setShowBillingModal(false)}
                initialData={billingForm || undefined}
                onSubmit={handleBillingSubmit}
            />
            <RaiseRequestModal
                show={showRaiseRequestModal}
                onClose={() => setShowraiseRequestModal(false)}
                onSubmit={handleRaiseSubmit}
                meta={raiseMeta} // <-- pass meta to modal
                />
        </MainContainer>
    )
}

export default APIDetailsPage
